import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../index";
import { locationLicense } from "@/types";

export type TypeModal = {
  license: boolean;
  status: boolean;
  content: boolean;
};
interface CounterStateType {
  license?: locationLicense;
  modal: TypeModal;
}

// Define the initial state using that type
const initialState: CounterStateType = {
  license: undefined,
  modal: {
    license: false,
    status: false,
    content: false,
  },
};

export const selectedSlice = createSlice({
  name: "selected",
  initialState,
  reducers: {
    setLicense: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.license = action.payload;
    },
    setModal: (state, action) => {
      const da = action.payload as CounterStateType["modal"];
      state.modal = { ...state.modal, ...da };
    },
  },
});
export const { setLicense, setModal } = selectedSlice.actions;
// Other code such as selectors can use the imported `RootState` type
export const getLicense = (state: RootState) => state.selected.license;
export const getModal = (state: RootState) => state.selected.modal;

export default selectedSlice.reducer;
